import React from "react";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import DataTypeGrid from "./DataTypeGrid";
import {DataTypeTranslationKey} from "./DataTypeTranslationKey";


export default function StereotypesPage() {
    return(
        <Page>
            <PageHeader>
                <PageTitle title={t(DataTypeTranslationKey.DATA_TYPES)} />
            </PageHeader>
            <PageContent>
                <DataTypeGrid />
            </PageContent>
        </Page>
    )
}
